import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=66231d26&scoped=true&"
import script from "./customerInfo.vue?vue&type=script&lang=js&"
export * from "./customerInfo.vue?vue&type=script&lang=js&"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=66231d26&scoped=scoped&lang=css&"
import style1 from "./customerInfo.vue?vue&type=style&index=1&id=66231d26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66231d26",
  null
  
)

export default component.exports